import { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AeonyxIcon, AeonyxWordmark } from "@/components/aeonyx/Logo";
import AuthForm from "@/components/auth/AuthForm";

export default function Login() {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const requestedFrom = location.state?.from;

  useEffect(() => {
    if (loading || !isAuthenticated) return;
    // Admins always go to the admin dashboard unless they explicitly asked for another admin route.
    if (isAdmin) {
      const target = requestedFrom && requestedFrom.startsWith("/admin") ? requestedFrom : "/admin/dashboard";
      navigate(target, { replace: true });
    } else {
      const target = requestedFrom && !requestedFrom.startsWith("/admin") ? requestedFrom : "/";
      navigate(target, { replace: true });
    }
  }, [isAuthenticated, isAdmin, loading, navigate, requestedFrom]);

  return (
    <div className="min-h-screen bg-cool-white flex items-center justify-center px-5 py-16 relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-60 bg-[radial-gradient(circle_at_20%_20%,rgba(1,207,198,0.14),transparent_50%),radial-gradient(circle_at_80%_60%,rgba(2,47,107,0.09),transparent_55%)]"
      />
      <div className="relative w-full max-w-md">
        <div className="rounded-3xl border border-[#8A97A8]/25 bg-white/95 backdrop-blur-xl p-8 pt-10 shadow-[0_30px_60px_-20px_rgba(2,47,107,0.2)]">
          <AuthForm
            mode="signin"
            onModeChange={(m) => {
              if (m === "signup") navigate("/signup", { state: { from: requestedFrom } });
              else if (m === "reset") navigate("/forgot-password");
            }}
            onSuccess={() => { /* redirect handled by effect above */ }}
            compact
            header={
              <div className="flex flex-col items-center text-center gap-4 mb-2">
                <Link
                  to="/"
                  aria-label="Aeonyx Life Sciences — Home"
                  className="inline-flex flex-col items-center gap-4"
                >
                  <AeonyxIcon className="h-24 md:h-28 w-auto" priority />
                  <AeonyxWordmark className="h-14 md:h-16 w-auto" priority />
                </Link>
              </div>
            }
          />
        </div>
        <p className="mt-6 text-center text-[11px] text-cool-grey">
          By continuing you agree to Aeonyx&apos;s Terms &amp; Privacy.
        </p>
      </div>
    </div>
  );
}
